import { useTranslation } from 'react-i18next';
import AmountInput from '../AmountInput';
import FilterCheckbox from './FilterCheckbox';
import type { OperationColumnFilters } from './types';

interface AmountFilterContentProps {
  value: OperationColumnFilters['amount'];
  onChange: (next: OperationColumnFilters['amount']) => void;
}

export default function AmountFilterContent({ value, onChange }: AmountFilterContentProps) {
  const { t } = useTranslation('operations');

  const toggleType = (type: 'credit' | 'debit') => {
    const types = value.types.includes(type)
      ? value.types.filter((tp) => tp !== type)
      : [...value.types, type];
    onChange({ ...value, types });
  };

  return (
    <div className="space-y-2 w-[180px]">
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">
          {t('filters.amountMin')}
        </label>
        <AmountInput
          value={value.min}
          onChange={(v) => onChange({ ...value, min: v })}
          className="w-full"
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">
          {t('filters.amountMax')}
        </label>
        <AmountInput
          value={value.max}
          onChange={(v) => onChange({ ...value, max: v })}
          className="w-full"
        />
      </div>
      <div className="pt-1 border-t border-gray-100">
        <FilterCheckbox
          checked={value.types.includes('credit')}
          onChange={() => toggleType('credit')}
          label={t('filters.credit')}
        />
        <FilterCheckbox
          checked={value.types.includes('debit')}
          onChange={() => toggleType('debit')}
          label={t('filters.debit')}
        />
      </div>
    </div>
  );
}
